











































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber, getSnackbarMessage } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { useResolverPacienteDuplicado } from '@/composables'
import { TipoDocumentoBuscaPacienteEnum } from '@/types/_'

@Component
export default class ComponentModalBuscarPacienteBackoffice extends Vue {
  sel: any = {}
  select: any = {}
  loadCPF: boolean = false
  loadSearch: boolean = false
  loadUsarPaciente: boolean = false
  cpf: string = ''
  rgh: string = ''
  paciente: string = ''
  dataNascimento: string = ''
  tipoDocumentoBuscaPaciente: TipoDocumentoBuscaPacienteEnum = TipoDocumentoBuscaPacienteEnum.CPF
  paginationProps: any = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  buscarPacienteTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'CPF', value: 'cpf', sortable: false },
    { text: 'Data de nascimento', value: 'dataNascimento', sortable: false },
  ]

  get pacientes() {
    return this.getBackofficeGlobalStore.pacientesLista
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get loadingSearch() {
    return this.loadSearch
  }

  set loadingSearch(value: boolean) {
    this.loadSearch = value
  }

  get loadingCPF() {
    return this.loadCPF
  }

  set loadingCPF(value: boolean) {
    this.loadCPF = value
  }

  get loadingSelectPaciente() {
    return this.loadUsarPaciente
  }

  set loadingSelectPaciente(value: boolean) {
    this.loadUsarPaciente = value
  }

  get selected() {
    return this.sel
  }

  set selected(value: any) {
    this.sel = value
  }

  get buscarPaciente() {
    return this.getBackofficeGlobalStore.modal.buscarPaciente
  }

  get hospitalId() {
    return this.getBackofficeGlobalStore.hospitalId
  }

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  formatCPFOnly(c: string) {
    if (!c) return '-'
    return `${c.substring(0, 3)}.${c.substring(3, 6)}.${c.substring(6, 9)}-${c.substring(9, 11)}`
  }

  formatBirthday(value: string) {
    if (!value) return '-'
    return moment(value).format('DD/MM/YYYY')
  }

  formatConvenio(convenioId: string) {
    const convenio = this.getBackofficeGlobalStore.convenios.find((e: any) => e.id === convenioId)
    return convenio ? convenio.nome : ''
  }

  closeModalBuscarPaciente() {
    this.selected = {}
    this.getBackofficeGlobalStore.clearPacientesLista()
    this.getBackofficeGlobalStore.setShowModalBuscarPaciente(false)
  }

  async searchByDocumento() {
    if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.CPF && this.cpf.length < 11) return
    if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.RGH && !this.rgh.length) return
    this.loadingCPF = true
    await this.getBackofficeGlobalStore.getPacienteInfo({ hospitalId: this.hospitalId, cpf: this.cpf, rgh: this.rgh })
    this.loadingCPF = false
  }

  async search() {
    if (this.paciente.length < 3 || this.dataNascimento.length < 10) return
    this.loadingSearch = true
    await this.getBackofficeGlobalStore.getPacienteInfoByNomeAndDataNascimento({ hospitalId: this.hospitalId, nome: this.paciente, dataNascimento: this.dataNascimento })
    this.loadingSearch = false
  }

  async selectPaciente() {
    this.loadingSelectPaciente = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.getBackofficeGlobalStore.backofficeAgendamentoAtualizaPaciente(this.selected)

    if (response.success && response.data?.temPacienteDuplicado) {
      useResolverPacienteDuplicado.abrir({
        pacientesDuplicados: response.data.pacientesDuplicados,
        hospitalId: response.data.hospitalId,
        solicitacaoId,
        pacienteHisOriginal: this.selected,
      })
      this.closeModalBuscarPaciente()
      this.loadingSelectPaciente = false
      return
    }

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Paciente atualizado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      this.closeModalBuscarPaciente()
    } else {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Não foi possivel alterar o paciente', 'error'))
    }
    this.loadingSelectPaciente = false
  }

  tipoDocumentoBuscaPacienteChange() {
    if (this.tipoDocumentoBuscaPaciente === TipoDocumentoBuscaPacienteEnum.CPF) {
      this.rgh = ''
    } else {
      this.cpf = ''
    }
  }

  windowSize: number = 0

  get paddingButton() {
    return this.windowSize >= 768 ? 'pl-3' : ''
  }

  onResize() {
    this.windowSize = window.innerWidth
  }

  async mounted() {
    this.onResize()
  }

  @Watch('buscarPaciente')
  onChangeBuscarPaciente(value) {
    if (!value) {
      this.selected = {}
      this.getBackofficeGlobalStore.clearPacientesLista()
      this.cpf = ''
      this.paciente = ''
      this.dataNascimento = ''
    } else {
      this.setTipoDocumentoBuscaPaciente()
    }
  }

  campoHabilitado(prop: string) {
    if (this.getTemplate) {
      const response = this.getTemplate[prop]

      if (response) return response.habilitado
    }

    return false
  }

  setTipoDocumentoBuscaPaciente() {
    if (this.campoHabilitado('cpf') && this.campoHabilitado('rgh')) {
      this.tipoDocumentoBuscaPaciente = this.getTemplate.cpf.principal ? TipoDocumentoBuscaPacienteEnum.CPF : TipoDocumentoBuscaPacienteEnum.RGH
    } else if (this.getTemplate.cpf && this.getTemplate.cpf.habilitado) {
      this.tipoDocumentoBuscaPaciente = TipoDocumentoBuscaPacienteEnum.CPF
    } else if (this.getTemplate.rgh && this.getTemplate.rgh.habilitado) {
      this.tipoDocumentoBuscaPaciente = TipoDocumentoBuscaPacienteEnum.RGH
    }
  }
}

